



















































import { Component, Prop, Vue } from 'vue-property-decorator'
import RemoveTag from '@/components/Parts/RemoveTag.vue'
import VueSimpleSuggest from 'vue-simple-suggest'

@Component({
  components: { RemoveTag, VueSimpleSuggest }
})
export default class PdfFIlter extends Vue {
  /**
   * サジェスト対象となるリスト
   */
  @Prop() private suggest!: string[]
  /**
   * フィルタの可否
   */
  @Prop({ default: false }) private filter?: boolean

  // --------------------------------------------------------------------------------------------------------------------
  // data

  private keyword = ''
  private doFocus = false

  // --------------------------------------------------------------------------------------------------------------------
  // hooks

  private updated() {
    // DOMが更新されたら強調表示させる
    if (this.doFocus) {
      this.focusKeyword()
      this.doFocus = false
    }
  }

  // --------------------------------------------------------------------------------------------------------------------
  // computed
  /**
   * サジェスト用のリスト
   */
  get suggestList() {
    const keyword = this.keyword.toLowerCase().trim()
    return this.suggest.filter((i) => i.toLowerCase().trim().includes(keyword))
  }

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * 検索クリック時の動作
   */
  private search(keyword: string) {
    this.keyword = keyword
    this.$emit('search', keyword)

    this.doFocus = true
  }

  /**
   * リセットクリック時の動作
   */
  private reset() {
    this.keyword = ''
    this.search('')
  }

  /**
   * 強調表示
   */
  private focusKeyword() {
    const target = this.$refs.target as Element as HTMLElement

    const selector = '[data-class="keyword-target"]'

    // 強調解除
    window.replaceSearchKeyword(selector, '', 'reverse', target)

    // 強調
    const keyword = this.keyword.trim()
    window.replaceSearchKeyword(selector, keyword, 'forward', target)
  }
}
